import { useRef } from 'react'

import { EmailModalReplyForm } from '../../../EmailModalReplyForm'

export function useEmailProfileMessageFullScreenModalReplyForm({
  PriorityFieldComponent,
  aiLocalContext,
  attachProps,
  getContainerIsDirty,
  getIsDirty,
  handleCancelReply,
  handleClickRemoveReplyDraft,
  handleInitReplyEditor,
  handleSubmitReply,
  handleSuccessReply,
  recipientsFilterModalInitialValues,
  setModal,
  setReplyFormInitialValues,
  singleTemplateFolder,
  templateEntityApiParams,
  templateListApiParams,
  withServiceAccount,
}) {
  const formRef = useRef(null)

  function handleCloseModalReplyForm() {
    setModal(null)

    handleCancelReply()
  }

  async function handleSuccessModalReplyForm(data) {
    return handleSuccessReply(data).then(() => {
      setModal(null)
    })
  }

  function handleExitFromFullScreen() {
    setReplyFormInitialValues(formRef.current.values)

    setModal(null)
  }

  function handleMakeReplyFormFullScreen(initialValues) {
    setModal(
      <EmailModalReplyForm
        aiLocalContext={aiLocalContext}
        externalRef={formRef}
        formBodyActionsProps={{
          MakeFormFullScreenButton: null,
          onRemoveDraft: handleClickRemoveReplyDraft,
        }}
        formFieldsProps={{
          PriorityFieldComponent,
          attachProps,
          templateListApiParams,
        }}
        getContainerIsDirty={getContainerIsDirty}
        getIsDirty={getIsDirty}
        initialValues={initialValues}
        recipientsFilterModalInitialValues={recipientsFilterModalInitialValues}
        resizeConfig={{
          initialFullScreen: true,
          onExitFromFullScreen: handleExitFromFullScreen,
        }}
        singleTemplateFolder={singleTemplateFolder}
        templateEntityApiParams={templateEntityApiParams}
        withServiceAccount={withServiceAccount}
        onClose={handleCloseModalReplyForm}
        onInitEditor={handleInitReplyEditor}
        onSubmit={handleSubmitReply}
        onSuccess={handleSuccessModalReplyForm}
      />
    )
  }

  return {
    handleMakeReplyFormFullScreen,
  }
}
